import { useState } from 'react'

const NAV_LINKS = ['Nossa visão', 'Como funciona', 'A experiência']

export default function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-base-100/90 backdrop-blur-sm border-b border-black/5">
      <div className="max-w-[1280px] mx-auto px-4 h-[72px] flex items-center justify-between">

        {/* Logo */}
        <a href="/" aria-label="TLC Home" className="shrink-0">
          <img src="/assets/logo.svg" alt="TLC" className="h-6 w-auto" />
        </a>

        {/* Nav links — tablet + desktop */}
        <nav className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((item) => (
            <a
              key={item}
              href="#"
              className="text-sm font-semibold text-zinc-900/80 hover:text-zinc-900 px-3 py-2 rounded-full transition-colors"
            >
              {item}
            </a>
          ))}
        </nav>

        {/* Login button — tablet + desktop */}
        <div className="hidden md:flex items-center">
          <a
            href="#"
            className="btn btn-sm border border-zinc-900 text-zinc-900 bg-transparent hover:bg-zinc-900 hover:text-white rounded-full gap-1.5 font-semibold"
          >
            Login
            <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z" />
            </svg>
          </a>
        </div>

        {/* Mobile: circular menu button */}
        <button
          className="md:hidden w-10 h-10 rounded-full border border-zinc-900 flex items-center justify-center"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          <svg className="w-5 h-5 text-zinc-900" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16" />
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden bg-base-100 border-t border-black/5 px-4 pb-4">
          <nav className="flex flex-col gap-1 pt-2">
            {NAV_LINKS.map((item) => (
              <a key={item} href="#" className="text-sm font-semibold text-zinc-900 py-2 px-3 rounded-xl hover:bg-zinc-900/5">
                {item}
              </a>
            ))}
            <a href="#" className="mt-2 btn btn-sm border border-zinc-900 text-zinc-900 bg-transparent rounded-full font-semibold self-start">
              Login
            </a>
          </nav>
        </div>
      )}
    </header>
  )
}
